// src/pages/beta-community/BetaContractPage.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './BetaContractPage.css';
import { ROOT_HOST, ROOT_URL, VISION_HOST } from '../../config/domains';

const BetaContractPage = () => {
  const navigate = useNavigate();
  const [accepted, setAccepted] = useState(false);

  const handleAccept = () => {
    if (!accepted) {
      alert('Veuillez cocher la case pour accepter les termes du contrat.');
      return;
    }
    
    // TODO: Enregistrer l'acceptation dans Supabase
    alert('Contrat accepté ! Nous vous recontacterons sous 24h pour finaliser votre inscription.');
    navigate('/rejoindre-la-communaute');
  };

  const handleDownload = () => {
    // TODO: Générer PDF ou télécharger le DOCX
    alert('Téléchargement du contrat...');
  };

  return (
    <div className="contract-page" style={{ fontFamily: "'Georgia', serif" }}>
      <div className="contract-header">
        <h1 className="contract-logo">ARTKIV</h1>
        <p className="contract-subtitle">Accord de participation Beta Community</p>
      </div>

      <div className="contract-container">
        <div className="contract-actions">
          <button className="btn btn-secondary" onClick={handleDownload}>
            Télécharger PDF
          </button>
        </div>

        <div className="contract-content">
          {/* Parties */}
          <section className="contract-section">
            <h2 className="contract-h2">Entre :</h2>
            <div className="contract-party">
              <strong>ARTKIV</strong><br />
              Représenté par Vanessa Quang, Fondatrice<br />
              Ci-après dénommé « Artkiv »
            </div>
          </section>

          <section className="contract-section">
            <h2 className="contract-h2">Et :</h2>
            <div className="contract-party">
              <strong>LE MEMBRE BÊTA</strong><br />
              [Nom et prénom à compléter lors de la signature en ligne]<br />
              Ci-après dénommé « le Membre Bêta »
            </div>
          </section>

          {/* Articles */}
          <section className="contract-section">
            <h1 className="contract-h1">Article 1 — Objet</h1>
            <p>
              Le présent accord définit les conditions de participation du Membre Bêta au programme bêta privé de la plateforme Artkiv, plateforme européenne de gestion, valorisation et transmission des collections, combinant intelligence artificielle, traçabilité numérique et expertise humaine.
            </p>
          </section>

          <section className="contract-section">
            <h1 className="contract-h1">Article 2 — Durée du programme</h1>
            <p><strong>Phase bêta gratuite :</strong> 6 mois à compter de l'activation du compte</p>
            <p><strong>Phase tarif réduit :</strong> 6 mois supplémentaires avec réduction de 30%</p>
            <p>
              Le Membre Bêta peut mettre fin à sa participation à tout moment, sans frais ni pénalité, 
              par simple email à <strong>support@artkiv.com</strong>.
            </p>
          </section>

          <section className="contract-section">
            <h1 className="contract-h1">Article 3 — Plan sélectionné</h1>
            <ul className="plan-list">
              <li>☐ Standard Collectionneur (29€/mois) — Valeur bêta : 174€</li>
              <li>☐ Premium Collectionneur (199€/mois) — Valeur bêta : 1.194€</li>
              <li>☐ Art Advisor (99€/mois) — Valeur bêta : 594€</li>
              <li>☐ Art Advisor Premium (199€/mois) — Valeur bêta : 1.194€</li>
              <li>☐ Family Office / CGP (299€/mois) — Valeur bêta : 1.794€</li>
            </ul>
            <p className="tarif-info">
              <strong>Tarif Phase 1 (mois 1-6) :</strong> 0€/mois (gratuit)<br />
              <strong>Tarif Phase 2 (mois 7-12) :</strong> [Prix plan] × 0,70 = Tarif réduit -30%
            </p>
          </section>

          <section className="contract-section">
            <h1 className="contract-h1">Article 4 — Engagements du Membre Bêta</h1>
            <p>Le Membre Bêta s'engage à :</p>
            <ul className="engagement-list">
              <li>
                <strong className="green">✓ Feedback mensuel :</strong> 1 call de 15-30 minutes par mois OU questionnaire écrit
              </li>
              <li>
                <strong className="green">✓ Signalement des bugs :</strong> Reporting des dysfonctionnements rencontrés
              </li>
              <li>
                <strong className="green">✓ Témoignage :</strong> 1 témoignage écrit (150-250 mots) OU vidéo (2-3 min) 
                à la fin des 6 mois, avec autorisation d'utilisation sur site web et réseaux sociaux 
                (possibilité d'anonymisation)
              </li>
              <li>
                <strong className="green">✓ Confidentialité :</strong> Ne pas partager publiquement les fonctionnalités 
                en développement ni les conditions bêta
              </li>
            </ul>
          </section>

          <section className="contract-section">
            <h1 className="contract-h1">Article 5 — Engagements d'Artkiv</h1>
            <p>Artkiv s'engage à :</p>
            <ul className="engagement-list">
              <li>
                <strong>✓ Accès au parcours sélectionné :</strong> Fournir l’accès au plan retenu et aux fonctionnalités disponibles pendant la bêta
              </li>
              <li>
                <strong>✓ Accompagnement :</strong> Support prioritaire raisonnable et accompagnement personnalisé lors de l'onboarding
              </li>
              <li>
                <strong>✓ Sécurité & confidentialité :</strong> Hébergement en Europe, conformité RGPD, accès contrôlés et absence de revente des données
              </li>
              <li>
                <strong>✓ Tarif privilégié :</strong> Garantir les conditions fondatrices prévues dans l’accord signé à l’issue de la période bêta
              </li>
            </ul>
          </section>

          <section className="contract-section">
            <h1 className="contract-h1">Article 6 — Propriété des données</h1>
            <p>
              <strong>Le Membre Bêta reste propriétaire à 100% de ses données.</strong> Artkiv ne peut 
              utiliser ces données que pour fournir le service. Export complet possible à tout moment 
              (JSON/CSV/PDF). Les retours et suggestions partagés peuvent être utilisés par Artkiv pour 
              améliorer la plateforme sans compensation financière.
            </p>
          </section>

          <section className="contract-section">
            <h1 className="contract-h1">Article 7 — Résiliation</h1>
            <p>
              <strong>Par le Membre Bêta :</strong> Résiliation libre à tout moment par email sans frais, 
              pénalité ni justification. Suppression des données sous 48h si demandée.
            </p>
            <p>
              <strong>Par Artkiv :</strong> Possible en cas de non-respect des engagements (pas de feedback 
              pendant 2 mois), utilisation abusive, ou violation des CGU, avec préavis de 15 jours minimum.
            </p>
          </section>

          <section className="contract-section">
            <h1 className="contract-h1">Article 8 — Limitation de responsabilité</h1>
            <p>
              <em>Le Membre Bêta reconnaît que la plateforme est en phase de développement.</em> Des bugs, dysfonctionnements ou interruptions peuvent survenir. Artkiv met tout en œuvre pour sécuriser les données et stabiliser la plateforme, mais ne peut être tenu responsable des pertes indirectes.
            </p>
            <p>Le Membre Bêta est encouragé à exporter régulièrement ses données.</p>
          </section>

          <section className="contract-section">
            <h1 className="contract-h1">Article 9 — Loi applicable</h1>
            <p>
              Le présent accord est soumis au droit français. Tout litige sera soumis aux tribunaux
              compétents de Paris.
            </p>
          </section>

          <section className="contract-section">
            <h1 className="contract-h1">Article 10 — Langue faisant foi</h1>
            <p>
              La version française des accords juridiques et des politiques est considérée comme la seule
              version actuelle et valide de ce document. Toute version traduite n'est fournie que pour votre
              commodité, afin de faciliter la lecture et la compréhension de la version française. Les versions
              traduites ne sont pas juridiquement contraignantes et ne peuvent remplacer les versions françaises.
              En cas de désaccord ou de conflit, les accords et politiques juridiques en langue française
              prévaudront.
            </p>
          </section>

          {/* Signature */}
          <section className="contract-section signature-section">
            <div className="signature-info">
              <p><em>Fait en 2 exemplaires électroniques,</em></p>
              <p><em>À ________________, le _____ / _____ / 2026</em></p>
            </div>

            <div className="signature-grid">
              <div className="signature-block">
                <p><strong>Pour ARTKIV :</strong></p>
                <p>Vanessa Quang, Fondatrice</p>
                <p>Signature : _________________________</p>
              </div>

              <div className="signature-block">
                <p><strong>Pour le BETA TESTEUR :</strong></p>
                <p>Nom : ______________________________</p>
                <p>Fonction : ______________________________</p>
                <p>Signature électronique : _________________________</p>
              </div>
            </div>
          </section>

          {/* Acceptation */}
          <section className="contract-section acceptance-section">
            <label className="acceptance-checkbox">
              <input
                type="checkbox"
                checked={accepted}
                onChange={(e) => setAccepted(e.target.checked)}
              />
              <span className="acceptance-text">
                ☑ J'ai lu et j'accepte les termes de cet accord
              </span>
            </label>
          </section>

          {/* Footer contractuel */}
          <section className="contract-section contract-footer-section">
            <h3 className="footer-title">COORDONNÉES ARTKIV</h3>
            <p>
              Email général : <a href="mailto:support@artkiv.com">support@artkiv.com</a><br />
              Email beta : <a href="mailto:support@artkiv.com">support@artkiv.com</a><br />
              Email support : <a href="mailto:support@artkiv.com">support@artkiv.com</a>
            </p>
            <p>
              Site web : <a href={ROOT_URL}>{ROOT_HOST}</a><br />
              Plateforme IA : <a href={`https://${VISION_HOST}`}>{VISION_HOST}</a>
            </p>
            <p className="version-info">Document version 2.0 — Décembre 2024</p>
          </section>
        </div>

        {/* Actions finales */}
        <div className="contract-final-actions">
          <button 
            className="btn btn-primary" 
            onClick={handleAccept}
            disabled={!accepted}
          >
            Accepter et Continuer
          </button>
          <button 
            className="btn btn-secondary" 
            onClick={() => navigate('/rejoindre-la-communaute')}
          >
            Retour
          </button>
        </div>
      </div>
    </div>
  );
};

export default BetaContractPage;